// @flow
import i18n from 'i18next';

i18n.loadNamespaces('commonAuthentication');

export type ErrorCode =
  | 'EMAIL_EMPTY'
  | 'EMAIL_INVALID'
  | 'PASSWORD_INVALID'
  | 'PASSWORD_EMPTY'
  | 'PASSWORDS_NOT_SIMILAR'

type ValidationResult = {
  isValid: boolean,
  errorCode?: ErrorCode,
};

export function emailValidator(email?: string): ValidationResult {
  if (!email) {
    return { isValid: false, errorCode: 'EMAIL_EMPTY' };
  }
  if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
    return { isValid: false, errorCode: 'EMAIL_INVALID' };
  }
  return { isValid: true };
}

export function passwordValidator(password?: string): ValidationResult {
  if (!password) {
    return { isValid: false, errorCode: 'PASSWORD_EMPTY' };
  }
  if (!isPasswordValid(password)) {
    return { isValid: false, errorCode: 'PASSWORD_INVALID' };
  }
  return { isValid: true };
}

export function resetPasswordValidator(password?: string, passwordValidaton?: string): ValidationResult {
  if (password && passwordValidaton && password !== passwordValidaton) {
    return { isValid: false, errorCode: 'PASSWORDS_NOT_SIMILAR' };
  }
  return { isValid: true };
}

const isPasswordValid = (password: string): boolean => {
  const hasNumericChars = /[0-9]/.test(password);
  const hasUppercaseChars = /[A-Z]/.test(password);
  const hasSpecialChars = /[^\w]/.test(password);
  const hasAtleastEightChars = password.length >= 8;

  return (hasNumericChars || hasUppercaseChars || hasSpecialChars) && hasAtleastEightChars;
};

export function mapErrorCode(code?: ErrorCode): ?string {
  if (!code) {
    return undefined;
  }

  return {
    'EMAIL_EMPTY': i18n.t('commonAuthentication:emailEmptyMessage'),
    'EMAIL_INVALID': i18n.t('commonAuthentication:emailInvalidMessage'),
    'PASSWORD_EMPTY': i18n.t('commonAuthentication:passwordEmptyMessage'),
    'PASSWORD_INVALID': i18n.t('commonAuthentication:passwordInvalidMessage'),
    'PASSWORDS_NOT_SIMILAR': i18n.t('commonAuthentication:passwordNotSimilarMessage'),
  }[code];
}



// WEBPACK FOOTER //
// ./src/common/modules/authentication/domain/validations.js